import { Aero } from 'src/api';

/* eslint-disable @typescript-eslint/naming-convention */
export const aeroConfig: Aero = {
  config_type: Aero.config_type.AERO,
};
